// src/components/PDF/OrdenPagoPDF.js

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
function formatearFechaUTC(fechaISO) {
    const [anio, mes, dia] = fechaISO.split('T')[0].split('-')
    const meses = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ]
    return `${parseInt(dia)} de ${meses[parseInt(mes) - 1]} del ${anio}`
}
function formatearMoneda(valor) {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
    }).format(valor)
}
const generarSeguroPDF = async (datos, logoBase64) => {
    return new Promise((resolve, reject) => {
        const doc = new jsPDF({
            orientation: 'landscape'
        })
        const colorPrincipal = [0, 148, 202] // #0094CA
        const margen = 20
        const pageWidth = doc.internal.pageSize.getWidth()
        const pageHeight = doc.internal.pageSize.getHeight()

        try {
            // Logo
            if (logoBase64) {
                const imgProps = doc.getImageProperties(logoBase64)
                const imgWidth = 35
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width
                doc.addImage(logoBase64, 'PNG', margen, 35, imgWidth, imgHeight)
            }

            // Título
            doc.setFontSize(18)
            doc.setTextColor(...colorPrincipal)
            doc.text('SEGUROS POR VENCER', pageWidth / 2, 20, { align: 'center' })

            // Línea decorativa
            doc.setDrawColor(...colorPrincipal)
            doc.setLineWidth(0.8)
            doc.line(margen, 25, pageWidth - margen, 25)


            // Datos generales
            doc.setFontSize(12)
            doc.setTextColor(50, 50, 50)
            const lineHeight = 7
            let y = 42

            // doc.text(`Folio: ${datos.folio}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
            // doc.text(`Fecha Máxima de Pago: ${datos.fechaMaxPago.split("T")[0]}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
            // doc.text(`Proveedor: ${datos.proveedor}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
            // doc.text(`RFC: ${datos.rfc}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
            // doc.text(`Método de pago: ${datos.metodoPago}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight + 5


            const tablaBancoY = 30

            // Tabla de conceptos
            autoTable(doc, {
                startY: tablaBancoY,
                head: [['Aseguradora', 'Poliza', 'Tipo', 'Fecha Emisión', 'Fecha de Inicio', 'Fecha de Vencimiento', 'Forma de Pago', 'Costo Total']],
                body: datos.map(c => [
                    c.compania,
                    c.poliza,
                    c.tipo,
                    formatearFechaUTC(c.fechaemision),
                    formatearFechaUTC(c.finicio),
                    formatearFechaUTC(c.fvencimiento),
                    c.formapago,
                    formatearMoneda(c.costototal),
                ]),
                styles: { fontSize: 10, cellPadding: 3 },
                headStyles: {
                    fillColor: colorPrincipal,
                    textColor: 255,
                    halign: 'center',
                    fontStyle: 'bold'
                },
                columnStyles: {
                    0: { halign: 'center' },
                    2: { halign: 'center' },
                    3: { halign: 'center' },
                    4: { halign: 'center' },
                    5: { halign: 'center' },
                    6: { halign: 'center' },
                    7: { halign: 'right' },
                },
                theme: 'grid'
            })

            // Footer
            const totalPages = doc.getNumberOfPages()
            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i)
                const contactoStartY = pageHeight - 35

                doc.setDrawColor(...colorPrincipal)
                doc.setLineWidth(0.5)
                doc.line(20, contactoStartY, pageWidth - 20, contactoStartY)

                doc.setFontSize(8)
                doc.setTextColor(100, 100, 100)
                doc.text('Arrendafit - contacto@arrendafit.com - www.arrendafit.com', pageWidth / 2, contactoStartY + 8, { align: 'center' })

                doc.setFontSize(9)
                doc.text(`Página ${i} de ${totalPages}`, pageWidth - 20, pageHeight - 10, { align: 'right' })
            }

            const base64 = doc.output('datauristring')
            resolve(base64)
        } catch (error) {
            console.log(error);
        }
    })


}

export { generarSeguroPDF }
